.form-section {
  width: 100%;
  height: auto;
  display: flex;
  margin-top: calc(var(--spacer) * 2.5);
  flex-direction: column;
}

.form-subtitle {
  margin-top: calc(var(--spacer) * 2.5);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

.form-field-label {
  width: var(--form-field-label-width);
  font-size: var(--body-size);
  padding-top: var(--spacer);
  color: var(--main-titles-inputs-600);
  display: inline-table;
}

.radio {
  display: flex;
  align-items: center;
}

#application-control-rules-title {
  margin-bottom: calc(var(--spacer)* -3); // remove extra space added by grid
}
